import {getPowtoonId} from './biSelectors'
export default {
  actionEvents: {  // (action, state, lastBITarget) =>  null OR {category, label, action, value, extraData}

  },

  domEvents: {  // (biTarget, event, domElement, state) => null OR {category, label, action, value, extraData}
    click: { //data-bi-target attribute on dom element
    },
    mouseUp: {}
  },

  reportEnhancers: [ // (event, state) => {} --> merged into extraData
    () => {
      return {
        powtoonId: getPowtoonId()
      }
    }
  ]
}
